import React from "react";

interface EnumOption {
  value: string;
  label: string;
}

interface EnumInputProps {
  value: string;
  options: EnumOption[];
  onChange: (value: string) => void;
}

export function EnumInput({ value, options, onChange }: EnumInputProps) {
  return (
    <select
      value={value}
      onChange={e => onChange(e.target.value)}
      className="w-full border rounded px-3 py-2">
      {options.map(opt => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
}
